import React, {useState} from 'react';
const SpinnerHexHuge = () => {

    const colors = {
        "orange":{start:"#f5aa5d",stop:"#d4720d"},
        "blue":{start:"#02b8c8",stop:"#077882"},
        "mustard":{start:"#f5e0b1",stop:"#b48924"},
        "lavender":{start:"#ea8af9",stop:"#97316f"},
        "olive":{start:"#baa826",stop:"#5d5517"},
        "green":{start:"#d4ea74",stop:"#798836"},
        "darkblue":{start:"#5b8aea",stop:"#25375b"}
    };

    let [color] = useState(colors["orange"]);
    //let thisId = Math.floor(Math.random() * 1000000);//to generate a different fill-id for each hex added to the DOM

//173.20508075688772
    return (
        <div id="spinnerHexHuge" className="littleHexButton" style={{position:"relative",opacity:0.5}} >

            <svg id="outerSpinner" style={{filter: "drop-shadow(rgba(0, 0, 0, 0.75) 1px 1px 3px",position:"absolute",left:0,top:0}} stroke="#fff" strokeWidth="2" width="220" height="190.5" viewBox="0 0 220 200" >
                <linearGradient id = "outerSpinnerHex" x1 = "0%" y1 = "0%" x2 = "0%" y2 = "100%">
                    <stop stopColor = {color.start} offset = "0%"/>
                    <stop stopColor = {color.stop} offset = "80%"/>
                </linearGradient>
                <path className="hex"  fill={"url(#outerSpinnerHex)"} d="M0 86.60254037844386L50 0L150 0L200 86.60254037844386L150 173.20508075688772L50 173.20508075688772Z" />
            </svg>

            <svg id="middleSpinner" style={{filter: "drop-shadow(rgba(0, 0, 0, 0.75) 1px 1px 3px",position:"absolute",left:9,top:7}} stroke="#02b8c8" strokeWidth="2" width="138" height="120" viewBox="0 0 220 200" >
                <linearGradient id = "middleSpinnerHex" x1 = "0%" y1 = "0%" x2 = "0%" y2 = "100%">
                    <stop stopColor = {color.start} offset = "0%"/>
                    <stop stopColor = {color.stop} offset = "80%"/>
                </linearGradient>
                <path className="hex"  fill={"url(#middleSpinnerHex)"} d="M0 86.60254037844386L50 0L150 0L200 86.60254037844386L150 173.20508075688772L50 173.20508075688772Z" />
            </svg>

            <svg id="innerSpinner" style={{filter: "drop-shadow(rgba(0, 0, 0, 0.75) 1px 1px 3px",position:"absolute",left:17,top:14}} stroke="#baa826" strokeWidth="2" width="60" height="52" viewBox="0 0 220 200" >
                <linearGradient id = "innerSpinnerHex" x1 = "0%" y1 = "0%" x2 = "0%" y2 = "100%">
                    <stop stopColor = {color.start} offset = "0%"/>
                    <stop stopColor = {color.stop} offset = "80%"/>
                </linearGradient>
                <path className="hex"  fill={"url(#innerSpinnerHex)"} d="M0 86.60254037844386L50 0L150 0L200 86.60254037844386L150 173.20508075688772L50 173.20508075688772Z" />
            </svg>

        </div>
    )
};

export default SpinnerHexHuge;
